import React, { useContext } from "react";
import { TeamOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { Card, Col, Row, Statistic, Select } from "antd";
import AppContext from "../../../../../config/AppContext";
import SwitchOrg from "../../../../common/SwitchOrg";

export default function FirstresponderDetails() {
  const { getProfilesList, switchOrgList, selectedOrg, getSelectedOrg } =
    useContext(AppContext);

  return (
    <div>
      <h1 style={{ textAlign: "center", fontSize: "40px", marginTop: "20%" }}>
        Welcome to the VIF Portal
      </h1>
      <Row gutter={[32, 32]}>
        <Col span={12} offset={6}>
          <SwitchOrg />
        </Col>
        <Col span={6} offset={6}>
          <Card className="card-container" bordered={false}>
            <Statistic
              title="All Accounts"
              value={getProfilesList(true).length || 0}
              valueStyle={{
                color: "#6a347d",
              }}
              prefix={<TeamOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card className="card-container" bordered={false}>
            <Statistic
              title="Accessible Accounts"
              value={getProfilesList(false).length || 0}
              valueStyle={{
                color: "#3f8600",
              }}
              prefix={<UserSwitchOutlined />}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
}
